// tienda/TecnologiaSection.jsx

import React from "react";
import { motion } from "framer-motion";
import { BarChart3, FileSpreadsheet, HandCoins, MapPin, MessageSquare, ShieldCheck } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

const FEATURES = [
  { icon: <ShieldCheck className="size-5" />, title: "Elegibilidad automática", text: "El sistema valida distritos, reintentos y condiciones del servicio al registrar." },
  { icon: <MapPin className="size-5" />, title: "Ubicación del driver", text: "Comparte avance, ETA y ruta referencial cuando la operación y conectividad lo permiten." },
  { icon: <MessageSquare className="size-5" />, title: "Cliente final informado", text: "Mensajes automáticos e interfaz con resumen para reducir preguntas y rechazos." },
  { icon: <HandCoins className="size-5" />, title: "COD y conciliación", text: "Cobranza visible, manejo de efectivo y control de depósitos para tus pedidos COD." },
  { icon: <FileSpreadsheet className="size-5" />, title: "Inventario + fulfillment", text: "Stock, packing y despacho desde Fast Max cuando el producto está en nuestro almacén." },
  { icon: <BarChart3 className="size-5" />, title: "Inteligencia operativa", text: "KPIs de éxito, rechazos, zonas, tiempos y presión logística para decidir mejor." },
];

export function TecnologiaSection() {
  return (
    <section id="tecnologia" className="border-b scroll-mt-16" style={{ background: brand.bg, borderColor: brand.line }}>
      <div className="mx-auto max-w-7xl px-4 py-14 md:py-20">
        <motion.div {...fadeUp} className="mb-10 max-w-3xl">
          <p className="mb-3 text-xs font-black uppercase tracking-[0.2em]" style={{ color: brand.primary }}>
            Plataforma
          </p>
          <h2 className="text-3xl font-black md:text-4xl" style={{ color: brand.ink }}>
            La tecnología detrás de cada entrega efectiva.
          </h2>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed md:text-base" style={{ color: brand.muted }}>
            Cada pedido genera datos operativos que ayudan a coordinar mejor, automatizar decisiones
            y construir una operación más predecible para ecommerce.
          </p>
        </motion.div>

        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((feature, index) => (
            <motion.div
              key={feature.title}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: index * 0.04 }}
              className="rounded-2xl border bg-white p-5 shadow-sm"
              style={{ borderColor: brand.line }}
            >
              <div className="mb-5 flex items-center justify-between">
                <div className="grid size-11 place-items-center rounded-xl" style={{ background: `${brand.primary}12`, color: brand.primary }}>
                  {feature.icon}
                </div>
                <span className="h-px flex-1 opacity-80" style={{ background: brand.line, marginLeft: 16 }} />
              </div>
              <h3 className="text-base font-black" style={{ color: brand.ink }}>{feature.title}</h3>
              <p className="mt-2 text-sm leading-relaxed" style={{ color: brand.muted }}>{feature.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
